import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex justify-content-center align-items-center flex-column" };
const _hoisted_2 = { class: "fw-bold text-primary" };
import { useI18n } from 'vue-i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'StandardLoadingDisplay',
    props: {
        infoText: {
            type: String
        },
    },
    setup(__props) {
        const { t } = useI18n();
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[0] || (_cache[0] = _createElementVNode("div", {
                    class: "spinner-grow text-primary mb-3",
                    role: "status",
                    style: { "width": "3rem", "height": "3rem" }
                }, [
                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                ], -1)),
                _createElementVNode("span", _hoisted_2, _toDisplayString(props.infoText || _unref(t)("Bitte warten. Auswahl wird geladen.")), 1)
            ]));
        };
    }
});
